<template>
    <div class="wrapper">
        <div class="orders">
            <div class="no-order" v-show='status == 0'>
                <div class="banner"></div>
                    <h2 class="title">
                        Loan History
                    </h2>
                    <p class="caption">
                        No order history go get your first loan
                    </p>
                    <div class="btn-container">
                        <router-link class="btn-submit" to="/" >Apply</router-link>
                    </div>
            </div>
            <div class="order-element" v-show='status == 1' v-for="(element,ind) in orders.list" :key="ind" :class="{'valid': ['1', '2', '6', '8', '11'].indexOf(element.orderState) != -1, 'invalid': ['3', '4', '5', '7', '9'].indexOf(element.orderState) != -1}">
                    <div class="tag" :class="{'valid': ['1', '2', '6', '8', '11'].indexOf(element.orderState) != -1, 'invalid': ['3', '4', '5', '7', '9'].indexOf(element.orderState) != -1}">
                        <span class="order_state" v-text="getStateText(element.orderState)"></span>
                    </div>
                    <div class="order-id" v-text="`${element.productName}`"></div>                
                    <ul class="order-info-list">
                        <li class="oi-element">
                            <span class="left">Loan Amount</span>
                            <span class="right" v-text="`₹ ${element.loanAmount}`"></span>
                        </li>
                        <!-- <li class="oi-element">
                            <span class="left">Tenure</span>
                            <span class="right" v-text="`${element.period} days`"></span>
                        </li> -->
                        <li class="oi-element">
                            <span class="left">Received</span>
                            <span class="right" v-text="`₹ ${element.arriveAmount}`"></span>
                        </li>
                        <li class="oi-element">
                            <span class="left">Repayment Amount</span>
                            <span class="right" v-text="`₹ ${element.repaymentAmount}`"></span>
                        </li>                        
                    </ul>
                    <router-link v-show="element.url != ''" class='wrapper-link' :to="`${element.url}`" ></router-link>
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, onMounted, ref } from 'vue'
import { getOrders } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
export default {
    setup () {
        const status = ref(2)
        const dict = {           
           "1": "Auditing",                     
           "2": "Pass",
           "3": "Denied", 
           "4": "Lending",
           "5": "Failed",
           "6": "Loaned",           
           "7": "Settled",
           "8": "Overdued",
           "11": "Extension"           
        }
        const orders = reactive({
            list:[]
        })
        const loading = useLoading()
        onMounted(()=>{
            const loader = loading.show({
                container: null
            })
            getOrders().then((res)=>{
                loader.hide()
                if(res.code == 0) {
                    orders.list = res.data.map((element)=>{
                        if(['1'].indexOf(element.orderState) != -1 ) {
                            element.url = `/orders/${element.orderId}/audit`
                        } else if ( element.orderState == '2' ) {
                            element.url = `/orders/${element.orderId}/confirm`
                        } else if (element.orderState == '6' || element.orderState == '8') {
                            element.url = `/orders/${element.orderId}/detail`
                        } else if (element.orderState == '11') {
                            element.url = `/orders/${element.orderId}/extension`
                        } else {
                            element.url = ''
                        }
                        return element
                    })
                    if(orders.list.length) {
                        status.value = 1
                    } else {
                        status.value = 0
                    }
                }
            })
        })
        const getStateText = (state) => {
            return dict[state]
        }
        return {
            orders,
            getStateText,
            status
        }
    }
}
</script>
<style lang="less" scoped>
    .wrapper{
        padding:50px;
        .orders{
            .no-order{
                .banner{
                    width: 236px;
                    height: 204px;
                    background:url("~assets/images/orders/order-banner.png") no-repeat;
                    background-size: 100% 100%;
                    margin: 0 auto
                }
                .title{
                    text-align: center;
                    font-size: 44px;
                    color:#000;
                    margin: 60px 0 30px 0;
                }
                .caption{
                    padding:30px 50px;
                    color:#A59BB3;
                    font-size: 32px;
                    line-height: 1.5;
                    white-space: nowrap;
                }
                .btn-container {
                    margin-top: 100px;            
                    width: 100%;
                    height: 96px;
                    .btn-submit {
                    display: block;
                    width: 670px;
                    height: 96px;
                    line-height: 96px;
                    text-align: center;
                    border-radius: 12px;
                    background: #52C9CF;
                    font-size: 32px;
                    margin: 0 auto;
                    color: #fff;
                    &.red{
                        background:#C5340B;
                    }
                    }
                }
            }
            .order-element{
                width: 654px; 
                background: #FFFFFF;
                box-shadow: 0px 22px 80px 0px rgba(0,0,0,0.0800);
                border-radius: 16px;
                position: relative;
                margin-bottom: 50px;
                .wrapper-link{
                    position: absolute;
                    z-index:999;
                    width: 654px;
                    height:100%;
                    top:0;
                    left:0;
                    right:0;
                    bottom:0;
                }
                &.valid{

                }
                &.invalid{
                    // .order-id{
                    //     color:#FF1F12;                        
                    // }
                    // .oi-element{
                    //     span.left{color:#FF1F12;}
                    //     span.right{color:#FF1F12;}
                    // }
                }
                .tag{
                    position: absolute;
                    top:25px;
                    right:20px;
                    width: 194px;
                    height: 50px;
                    
                    .order_state{
                        display: block;
                        width: 194px;
                        color:#fff;
                        font-size: 32px;                    
                        text-align: center;                                              
                        line-height: 50px;
                        // transform: rotate(31deg);
                    }
                    &.invalid{
                        background:url("~assets/images/orders/invalid.png") no-repeat;
                        background-size: 100% 100%;
                        .order_state{
                            color:#FF1F12;
                        }
                        
                    }
                    &.valid{
                        background:url("~assets/images/orders/valid.png") no-repeat;
                        background-size: 100% 100%;
                        .order_state{
                            color:#3BA8BE;
                        }
                    }
                }         
                .order-id{
                    padding:30px 40px;
                    border-bottom:2px solid #EFEEF1;
                    color:#333;
                    font-size: 30px;
                    font-weight: 700;
                    height:46px;
                    line-height: 46px;
                    text-align: left;
                }
                .order-info-list{
                    padding:30px;
                    .oi-element{
                        overflow:hidden;
                        margin-bottom: 30px;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        .left{
                            float:left;
                            color:#160544;
                            font-size: 32px;
                        }
                        .right{
                            float:right;
                            color:#160544;
                            font-size: 32px;
                        }
                    }
                }
            }
        }
    }
</style>